<!-- État COLLAPSÉ -->
@if (collapsed && (site$ | async)) {
  <div class="panel-collapsed">
    <button
      mat-icon-button
      class="collapsed-btn"
      (click)="toggleCollapsed()"
      matTooltip="{{'open_display_settings' | transloco | sentencecase}}">
      <mat-icon>tune</mat-icon>
    </button>
  </div>
}

<!-- État OUVERT -->
@if (!collapsed && (site$ | async); as site) {
  <div class="panel-card">
    <div class="panel-header">
      <div class="panel-title">{{'display' | transloco | sentencecase}}</div>
      <button
        mat-icon-button
        class="collapse-btn"
        type="button"
        (click)="toggleCollapsed()"
        matTooltip="{{'close' | transloco}}">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="panel-content">
      <section class="panel-section">
        <h4 class="section-title">{{'scene_mode' | transloco | sentencecase}}</h4>
        <view-representation-selector class="full-width"></view-representation-selector>
      </section>
      @if (isPointCloudDisplayed) {
        <section class="panel-section">
          <h4 class="section-title">{{'settings' | transloco | sentencecase}}</h4>
          <div class="setting-row">
            <view-point-cloud-size-slider class="full-width"></view-point-cloud-size-slider>
          </div>
          @if (
            site &&
            selectedViewRepresentation == viewRepresentation.DIFFERENTIAL &&
            (selectedTilesetConfig$ | async); as differentialTilesetConfig) {
            <div class="setting-row"
              >
              @if (differentialTilesetConfig.maxDistance) {
                <tileset-diff-color-ramp></tileset-diff-color-ramp>
              }
              @if (!differentialTilesetConfig.maxDistance) {
                <div>{{'computing' | transloco}}</div>
              }
            </div>
          }
        </section>
      }
      <!--    <section class="panel-section">-->
      <!--      <h4 class="section-title">{{'theorical_layers' | transloco | sentencecase}}</h4>-->
      <!--    <div class="references">-->
      <!--      <mat-button-toggle-group *ngIf="isComparedSelectorVisible"-->
      <!--                               [(value)]="comparedSelector"-->
      <!--                               [hideSingleSelectionIndicator]="true"-->
      <!--                               (change)="onComparedSelectorChanged($event.value)">-->
      <!--        <mat-button-toggle matTooltip="{{'batchs' | transloco}}" value="batchs">-->
      <!--          {{'batchs' | transloco}}-->
    <!--        </mat-button-toggle>-->
    <!--        <mat-button-toggle matTooltip="{{'layers' | transloco}}" value="layers">-->
    <!--          {{'theorical_layers' | transloco}}-->
  <!--        </mat-button-toggle>-->
<!--      </mat-button-toggle-group>-->
<!--      -->
<!--      <theorical-layer-selector [hidden]="comparedSelector !== 'layers'"></theorical-layer-selector>-->
<!--    </div>-->
<!--    </section>-->
<!--    <section class="panel-section" *ngIf="hasAnyAnnotation$ | async">-->
<!--      <h4 class="section-title">{{'annotations' | transloco | sentencecase}}</h4>-->
<!--      <div class="annotation-list" >-->
<!--        <mat-checkbox *ngIf="measureCount$ | async" [checked]="isDisplayMeasuresChecked$ | async" (change)="onToggleChangeDisplayMeasures($event)">-->
<!--          {{ 'measures' | transloco | uppercase }} ({{measureCount$ | async}})-->
<!--        </mat-checkbox>-->
<!--        <mat-checkbox *ngIf="cutCount$ | async" [checked]="isDisplayCutsChecked$ | async" (change)="onToggleChangeDisplayCuts($event)">-->
<!--          {{ 'cuts' | transloco | uppercase }} ({{cutCount$ | async}})-->
<!--        </mat-checkbox>-->
<!--        <mat-checkbox *ngIf="elevationCount$ | async" [checked]="isDisplayElevationsChecked$ | async" (change)="onToggleChangeDisplayElevations($event)">-->
<!--          {{ 'elevations' | transloco | uppercase }} ({{elevationCount$ | async}})-->
<!--        </mat-checkbox>-->
<!--        <mat-checkbox *ngIf="markerCount$ | async" [checked]="isDisplayMarkersChecked$ | async" (change)="onToggleChangeDisplayMarkers($event)">-->
<!--          {{ 'markers' | transloco | uppercase }} ({{markerCount$ | async}})-->
<!--        </mat-checkbox>-->
<!--        <mat-checkbox *ngIf="detectionCount$ | async" [checked]="isDisplayDetectionsChecked$ | async" (change)="onToggleChangeDisplayDetections($event)">-->
<!--          {{ 'detections' | transloco | uppercase }} ({{filteredDetectionCount$ | async}})-->
<!--        </mat-checkbox>-->
<!--        <mat-checkbox *ngIf="volumeCount$ | async" [checked]="isDisplayVolumesChecked$ | async" (change)="onToggleChangeDisplayVolumes($event)">-->
<!--          {{ 'volumes' | transloco | uppercase }} ({{volumeCount$ | async}})-->
<!--        </mat-checkbox>-->
<!--      </div>-->
<!--    </section>-->
</div>
</div>
}
